module.exports = __webpack_public_path__ + "img/ico9.6e4ff131.png";